import * as React from 'react';
import Box from '@mui/material/Box';
import { Button, FormControl, Stack, TextField, Typography, useMediaQuery } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../stores/store';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { EmailModalFormValues } from '../../models/generalEmail';
import agent from '../../api/agent';
import { toast } from 'react-toastify';

interface Props {
    type: string;
    subject: string;
    header: string;
}

const style = (isMobile: boolean) => {
    return ({
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: isMobile ? 400 : 360,
        bgcolor: '#DAE5F1',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    })
};

const EmailModal = ({ subject, header, type }: Props) => {
    const { modalStore } = useStore();
    const { closeModal } = modalStore;

    const matches = useMediaQuery('(min-width:900px)');
    const initialFormvalues: EmailModalFormValues = {
        subject: subject,
        body: '',
        type: '',
        toMail: ''
    }

    const submitHandler = async (formValues: EmailModalFormValues) => {
        if (formValues && formValues.body && formValues.subject) {
            try {
                formValues = {
                    ...formValues,
                    type: type
                }
                await agent.GeneralEmail.sendEmail(formValues);
                toast.success("Email sent successfully");
                return true;
            } catch (error) {
                return false;
            }
        }
        toast.info("Subject and message are required");
        return false;
    }
    return (
        <Box sx={style(matches)}>
            <Typography variant='h6' textAlign='center' >Email: {header}</Typography>
            <Formik
                initialValues={initialFormvalues}
                onSubmit={async (values: EmailModalFormValues, { setSubmitting, resetForm }) => {
                    setSubmitting(true);
                    const response = await submitHandler(values);
                    if (response) {
                        resetForm();
                        setSubmitting(false);
                        closeModal();
                    }
                    setSubmitting(false);
                }}
            >
                {({ values, handleChange, handleBlur, isSubmitting, setFieldValue }) => (
                    <Form>
                        <Stack direction='column' spacing={2} m={2} alignItems='center'>
                            <FormControl sx={{ width: 300 }}>
                                <Field
                                    type="text"
                                    component={TextField}
                                    id="subject"
                                    name="subject"
                                    placeholder="Subject"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.subject}
                                    variant="outlined"
                                />
                                <ErrorMessage className="error" name="subject" component="div" />
                            </FormControl>
                            <FormControl sx={{ width: 300 }}>
                                <Field
                                    type="text"
                                    component={TextField}
                                    id="body"
                                    name="message"
                                    placeholder="Message"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.body}
                                    variant="outlined"
                                    multiline
                                    rows={3}
                                    sx={{ whiteSpace: 'pre-wrap' }}
                                />
                                <ErrorMessage className="error" name="body" component="div" />
                            </FormControl>
                            <Stack
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                                spacing={2}
                                pt={2}
                            >
                                <Button size={matches ? "medium" : "small"} variant="contained" type='submit'
                                    disabled={!values.body || !values.subject || isSubmitting}>Send</Button>
                                <Button size={matches ? "medium" : "small"} variant="contained"
                                    onClick={() => closeModal()}>Cancel</Button>
                            </Stack>
                        </Stack>
                    </Form>
                )}
            </Formik>
        </Box >
    )
}
export default observer(EmailModal);